import { render, staticRenderFns } from "./SingleSelectDozenteneinsatz.vue?vue&type=template&id=c08885ea&"
import script from "./SingleSelectDozenteneinsatz.vue?vue&type=script&lang=js&"
export * from "./SingleSelectDozenteneinsatz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports